import { Injectable } from '@angular/core';
import { Auth, getAuth, onAuthStateChanged, signOut as firebaseSignOut, User } from '@angular/fire/auth';
import { Database, getDatabase, ref, push, remove as dbRemove, DatabaseReference } from '@angular/fire/database';
import { Functions, getFunctions, httpsCallable, HttpsCallable } from '@angular/fire/functions';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  private auth: Auth;
  private database: Database;
  private functions: Functions;
  
  constructor() {
    this.auth = getAuth();
    this.database = getDatabase();
    this.functions = getFunctions();
  }

  db(table: string): DatabaseReference {
    return ref(this.database, table);
  }

  create(table: string, data: object) {
    const dbRef = ref(this.database, table);
    push(dbRef, data);
  }

  remove(segment: string) {
    const dbRef = ref(this.database, segment);
    return dbRemove(dbRef);
  }

  getAuth(): Auth {
    return this.auth;
  }

  onAuthStateChange(): Observable<User | null> {
    return new Observable<User | null>(subscriber => {
      onAuthStateChanged(this.auth, user => {
        subscriber.next(user);
      });
    });
  }

  async signOut() {
    await firebaseSignOut(this.auth);
  }

  getFunction(name: string): HttpsCallable {
    return httpsCallable(this.functions, name);
  }
}
